import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {SvgIconsComponent} from './svg-icons.components'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgIconsComponent],
  exports: [
    SvgIconsComponent
  ]
})
export class SvgIconsModule {
}
